// Default imports
import React from "react";
import Timeline from "../components/Timeline";

const OurHistory = ({ timeline, title, text }) => (
    <Timeline events={timeline.events} title={title} text={text} />
);
export default OurHistory;
